import { render, staticRenderFns } from "./LifespanInfo.vue?vue&type=template&id=619b4c8c"
import script from "./LifespanInfo.vue?vue&type=script&lang=ts"
export * from "./LifespanInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports